import { Button, DataSourceMode, Panel, TableRow, TableRowExpansionEvent } from "@mcleod/components";
import { LogManager } from "@mcleod/core";
import { AutogenLayoutUnbilledOrders } from "./autogen/AutogenLayoutUnbilledOrders";

const log = LogManager.getLogger("lme.dispatch.UnbilledOrders");

export class UnbilledOrders extends AutogenLayoutUnbilledOrders {

    onRowExpand(event: TableRowExpansionEvent) {
        const tableRow: TableRow = event.target as TableRow;
        if (event.isExpanding) {
            tableRow.editRow();
            const expandPanel: Panel = event.expandComponentParent as Panel;

            this.tableUnbilledOrders.setRowsExpanded(false, (row: TableRow) => row.index !== tableRow.index);
            this._setExpandDatasource(tableRow.data.data["id"]);
            (expandPanel.findComponentById("btnSave") as Button).addClickListener(_event => this._saveTableRow(tableRow));
        }
    }

    private _setExpandDatasource(orderId: string) {
        this.sourceExpandedOrder.search({ id: orderId }).then(row => {
            this.sourceExpandedOrder.mode = DataSourceMode.UPDATE;
        })
    }

    private _saveTableRow(tableRow: TableRow) {
        log.debug("Saving row...", this.sourceExpandedOrder.activeRow);
        tableRow.data.post().then(savedRow => {
            tableRow.displayData(savedRow, this.mainDataSource.data, tableRow.index);
            tableRow.expanded = false;
        });

    }
}
